
const digest = 'ac01585d2176b15a4123c5873f7ab7f8e2d714ce6e85dca41029327486f471ae';
const classes = {"item":"_item_kld1u_1"};
const css = `._item_kld1u_1 {
  font-family: "Rubik", sans-serif;
  border-left: 4px solid #1665d8;
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  padding: 24px;
  border-top: 1px solid #eaedf3;
  border-bottom: 1px solid #eaedf3;
  border-right: 1px solid #eaedf3;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #000000;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  